import React from "react";
import { useTranslation } from "react-i18next";
import * as SM from "./Farms.mobile.styled";

const FarmFilterSheet = ({
  pendingFilters,
  onRegionSelect,
  onToggleProductType,
  onOrganicToggle,
  onDeliverySelect,
  onApply,
  onClearPending,
  onClose,
  regionOptions,
  productTypeOptions,
  deliveryWindowOptions,
}) => {
  const { t } = useTranslation();
  return (
    <SM.FilterOverlay role="presentation">
      <SM.FilterBackdrop
        type="button"
        aria-label={t("farms.filters.close", { defaultValue: "Close filters" })}
        onClick={onClose}
      />
      <SM.FilterSheet
        role="dialog"
        aria-modal="true"
        aria-label={t("farms.filters.title", { defaultValue: "Filter farms" })}
      >
        <SM.SheetDragHandle />
        <SM.SheetHeader>
          <SM.SheetTitle>
            {t("farms.filters.title", { defaultValue: "Filter farms" })}
          </SM.SheetTitle>
          <SM.SheetSubtitle>
            {t("farms.filters.subtitle", {
              defaultValue:
                "Narrow results by region, products, and delivery preferences.",
            })}
          </SM.SheetSubtitle>
        </SM.SheetHeader>
        <SM.SheetBody>
          <SM.Fieldset>
            <SM.Legend>
              {t("farms.filters.region.label", { defaultValue: "Region" })}
            </SM.Legend>
            <SM.ChipGroup>
              {regionOptions.map((option) => (
                <SM.Chip
                  key={option.value}
                  type="button"
                  $active={pendingFilters.region === option.value}
                  aria-pressed={pendingFilters.region === option.value}
                  onClick={() => onRegionSelect(option.value)}
                >
                  {option.label}
                </SM.Chip>
              ))}
            </SM.ChipGroup>
          </SM.Fieldset>

          <SM.Fieldset>
            <SM.Legend>
              {t("farms.filters.products.label", {
                defaultValue: "Product types",
              })}
            </SM.Legend>
            <SM.ChipGroup>
              {productTypeOptions.map((option) => (
                <SM.Chip
                  key={option.value}
                  type="button"
                  $active={pendingFilters.productTypes.includes(option.value)}
                  aria-pressed={pendingFilters.productTypes.includes(option.value)}
                  onClick={() => onToggleProductType(option.value)}
                >
                  {option.label}
                </SM.Chip>
              ))}
            </SM.ChipGroup>
          </SM.Fieldset>

          <SM.Fieldset>
            <SM.Legend>
              {t("farms.filters.organic.label", { defaultValue: "Organic" })}
            </SM.Legend>
            <SM.SwitchRow>
              {t("farms.filters.organic.copy", {
                defaultValue: "Show certified organic farms only",
              })}
              <SM.SwitchInput
                type="checkbox"
                checked={pendingFilters.organicOnly}
                onChange={(event) => onOrganicToggle(event.target.checked)}
              />
            </SM.SwitchRow>
          </SM.Fieldset>

          <SM.Fieldset>
            <SM.Legend>
              {t("farms.filters.delivery.label", {
                defaultValue: "Delivery window",
              })}
            </SM.Legend>
            <SM.ChipGroup>
              {deliveryWindowOptions.map((option) => (
                <SM.Chip
                  key={option.value}
                  type="button"
                  $active={pendingFilters.deliveryWindow === option.value}
                  aria-pressed={pendingFilters.deliveryWindow === option.value}
                  onClick={() => onDeliverySelect(option.value)}
                >
                  {option.label}
                </SM.Chip>
              ))}
            </SM.ChipGroup>
          </SM.Fieldset>
        </SM.SheetBody>

        <SM.FilterActions>
          <SM.FilterButton
            type="button"
            variant="primary"
            fullWidth
            onClick={onApply}
          >
            {t("farms.filters.apply", { defaultValue: "Apply filters" })}
          </SM.FilterButton>
          <SM.SecondaryButton
            type="button"
            variant="ghost"
            fullWidth
            onClick={onClearPending}
          >
            {t("farms.filters.reset", { defaultValue: "Reset" })}
          </SM.SecondaryButton>
        </SM.FilterActions>
      </SM.FilterSheet>
    </SM.FilterOverlay>
  );
};

export default FarmFilterSheet;
